import dragula from "dragula";
import "dragula/dist/dragula.css";

import { polyfill } from "mobile-drag-drop";
import { scrollBehaviourDragImageTranslateOverride } from "mobile-drag-drop/scroll-behaviour";

if (!window.__mobilePolyfillAdded) {
  polyfill({
    dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride,
    holdToDrag: 300,
    iterationInterval: 150,
  });
  window.__mobilePolyfillAdded = true;
}

export function reCreateNewDragula({ services, setServices, servicesRef }) {
  if (!servicesRef.current) return;

  window.newDragula?.destroy();

  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  window.newDragula = dragula([servicesRef.current], {
    moves: (el, source, handle, sibling) => {
      if (
        el.classList.contains("dragula-ignore") ||
        el.classList.contains("notDraggable")
      ) {
        return false;
      }

      if (!isMobile) {
        return true;
      }

      const isHandle = handle?.closest(".drag-group");
      return isHandle !== null;
    },
    ignoreInputTextSelection: true,
  });

  let isDragging = false;
  let preventScroll = (e) => {
    if (isDragging) {
      e.preventDefault();
    }
  };

  window.newDragula.on("drag", (el) => {
    isDragging = true;

    // Prevent scrolling during drag on mobile
    if (isMobile) {
      document.addEventListener("touchmove", preventScroll, { passive: false });
      document.addEventListener("scroll", preventScroll, { passive: false });
    }

    const mirror = document.querySelector(".gu-mirror");
    if (mirror) {
      mirror.style.width = `${el.offsetWidth}px`;
      mirror.style.height = `${el.offsetHeight}px`;

      const styles = getComputedStyle(el);
      mirror.style.borderRadius = styles.borderRadius;
      mirror.style.boxShadow = styles.boxShadow;
      mirror.style.background = styles.background;
    }
  });

  const enableScroll = () => {
    isDragging = false;
    if (isMobile) {
      document.removeEventListener("touchmove", preventScroll);
      document.removeEventListener("scroll", preventScroll);
    }
  };

  window.newDragula.on("dragend", (el) => {
    enableScroll();

    if (!el?.parentElement) return;

    const newServicesOrder = Array.from(
      el.parentElement.querySelectorAll(".new-service-card")
    ).map((node, index) => {
      const serviceId = Number(node.dataset.id);
      const service = services.find((s) => s.id === serviceId);
      return { ...service, order: index + 1 };
    });

    setServices(newServicesOrder);
  });

  window.newDragula.on("cancel", enableScroll);
  window.newDragula.on("drop", enableScroll);
}
